import { createContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (link: string) => {};

export const CheckoutContext = createContext(noop);
